import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  companyCodeSelector as initialCompanyCodeSelector,
  countryTaxTypeDescriptionsSelector,
} from '../../shared/store/selectors';

import {
  selectTaxYear as initialTaxYearSelector,
  selectCountryTaxType as initialCountryTaxTypeSelector,
} from '../aggregationMenu/store/selectors';

import {
  selectCompanyCodeIfExists as changeInitialCompanyCode,
} from '../../shared/store/actions';

import {
  changeCountryTaxType as changeInitialCountryTaxType,
  changeTaxYear as changeInitialTaxYear,
} from '../aggregationMenu/store/actions';

import { allCountryTaxes } from '../aggregationMenu/constants';

const useBsmContext = formik => {
  const { companyCode, taxYear, countryTaxType } = formik.values;

  const dispatch = useDispatch();

  const initialCompanyCode = useSelector(initialCompanyCodeSelector);
  const { value: initialTaxYear } = useSelector(initialTaxYearSelector) || {};
  const { value: initialCountryTaxType } = useSelector(initialCountryTaxTypeSelector) || {};

  const cttDescriptions = useSelector(countryTaxTypeDescriptionsSelector) || {};

  useEffect(() => {
    formik.setFieldValue('companyCode', initialCompanyCode);

    if (initialTaxYear && initialTaxYear > 0) {
      formik.setFieldValue('taxYear', initialTaxYear);
    }

    if (Object.keys(cttDescriptions).includes(initialCountryTaxType)) {
      formik.setFieldValue('countryTaxType', initialCountryTaxType);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (companyCode && countryTaxType && taxYear) {
      dispatch(changeInitialCompanyCode(companyCode));
      dispatch(changeInitialTaxYear({ value: taxYear, label: taxYear }));
      dispatch(changeInitialCountryTaxType({ value: countryTaxType, label: cttDescriptions[countryTaxType] }));
    } else {
      dispatch(changeInitialCompanyCode(null));
      dispatch(changeInitialTaxYear({ value: '-1', name: 'All' }));
      dispatch(changeInitialCountryTaxType(allCountryTaxes));
    }
  }, [companyCode, taxYear, countryTaxType, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useBsmContext;
